import React, { useCallback } from 'react';
import { Upload, message, InputNumber, ConfigProvider } from 'antd';
import ArrowUpIcon from "../../../assets/images/icons/arrow_up.svg";
import { CloseRounded } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { toggleTour } from '../../../reducers/tourSlice';
const { Dragger } = Upload;

const ReportUploadDragger = ({ handleFileSelect, fileList, handelWordChange, wordValue }) => {
    const dispatch = useDispatch();

    const beforeUpload = (file) => {
        // Define the allowed MIME type for PDF files
        const allowedMimeType = 'application/pdf';

        // Check if the file MIME type matches the expected PDF MIME type
        if (file.type === allowedMimeType) {
            // Read the file's first few bytes to validate it's a proper PDF
            const reader = new FileReader();

            reader.onloadend = () => {
                const buffer = reader.result;
                const uint8Array = new Uint8Array(buffer);

                // Check the first few bytes (PDF files start with "%PDF")
                const pdfHeader = "%PDF";
                const fileHeader = String.fromCharCode.apply(null, uint8Array.slice(0, 4));

                if (fileHeader !== pdfHeader) {
                    message.error('Invalid PDF file format');
                    // Reset file selection
                    handleFileSelect([]);  // Ensure this updates the file list properly
                    return Upload.LIST_IGNORE;
                }

                // Check if the file size is greater than 100MB
                if ((file.size / 1024 / 1024) > 100) {
                    message.error('File must be smaller than 100MB!');
                    handleFileSelect([]);  // Reset file selection on size error
                    return Upload.LIST_IGNORE;
                }

                // Check for special characters in file name (allowed characters: letters, numbers, dashes, and ampersands)
                const validFilenameRegex = /^[a-zA-Z0-9\-&_ ]+\.pdf$/;
                if (!validFilenameRegex.test(file.name)) {
                    message.error("File name contains invalid characters.");
                    handleFileSelect([]);
                    return Upload.LIST_IGNORE;
                }

                // Check for duplicate files in the file list
                const isDuplicate = fileList.some(existingFile => existingFile.name === file.name);
                if (isDuplicate) {
                    handleFileSelect([]);  // Reset file selection if duplicate
                    return Upload.LIST_IGNORE;
                }

                // If all checks pass, allow the upload to proceed
                return true;
            };

            reader.readAsArrayBuffer(file);  // Read the file as an array buffer
        } else {
            message.error('Invalid File format. File should be in PDF format');
            handleFileSelect([]);  // Reset file selection if format is incorrect
            return Upload.LIST_IGNORE;
        }
    };


    const handleFileChange = (file) => {
        handleFileSelect(file ?.fileList);
    };

    const customRequest = ({ file, onSuccess }) => {
        if (file && file.name) {
            onSuccess("ok");
        }
    }

    const onRemove = (index) => {
        const newFileList = fileList.filter((_, i) => i !== index);
        handleFileSelect(newFileList);
    };

    const handleClickOnDragger = () => {
        dispatch(toggleTour({ show: false }));
    }
    const stopdraggerPropogation = (event) => {
        event.stopPropagation();
    }
    const handleNwordChange = useCallback((value) => {
        handelWordChange(value)
    }, []);
    return (
        <div>
            <Dragger
                fileList={fileList}
                multiple={true}
                beforeUpload={beforeUpload}
                onChange={handleFileChange}
                customRequest={customRequest}
                showUploadList={false}
                onClick={handleClickOnDragger}
                disabled={fileList.length > 0}
            >
                <div className='upload-container-report' >
                    {
                        fileList.length === 0 ?
                            <div className='upload-action'>
                                <div className='title'>Drag and drop here or</div>
                                <button className="btn-outlined">
                                    <div className='btn-outlined-content'>
                                        <div className='text'>Upload documents </div>
                                        <img width={29} src={ArrowUpIcon} />
                                    </div>
                                </button>
                            </div>
                            :
                            <div className="upload-action" style={{ zIndex: 9999 }} onClick={() => { return; }}>
                                <div className="selectedList" >

                                    {
                                        fileList.map((item, index) => {
                                            return (
                                                <div className="filelistdiv" key={index}>

                                                    <p className="name" style={{ margin: "0" }}>{item.name}</p>
                                                    <CloseRounded className="remove" onClick={() => onRemove(index)} />
                                                </div>

                                            )
                                        })
                                    }
                                </div>
                            </div>
                    }
                    <div className='upload-action' onClick={stopdraggerPropogation} style={{ marginTop: "3px" }}>
                        <div className="file-report">
                            <span className="file-report-content">Select length of report</span>
                            <div className="input-number-div">
                                <div className="btn-outlined">
                                    <div className="btn-outlined-content">
                                        <ConfigProvider
                                            theme={{
                                                components: {
                                                    InputNumber: {
                                                        activeShadow: "0 0 0 2px rgba(255, 255, 255, 0.1)"
                                                    },
                                                },
                                            }}
                                        >
                                            <InputNumber size="large" min={30} max={300} defaultValue={wordValue} className="input-number" onChange={handleNwordChange} />
                                        </ConfigProvider>
                                    </div>
                                </div>
                                <p className="inputwords">Words</p>
                            </div>
                        </div>
                    </div>
                </div>

            </Dragger>

        </div>
    );
};

export default ReportUploadDragger;
